export default "__VITE_ASSET__5zi8QvfH__"